import type { FarmInfo, CreateFarmInput, UpdateFarmInput } from '@grosync/common';
import { apiRequest } from './client';

export const fetchFarms = (): Promise<FarmInfo[]> =>
  apiRequest<FarmInfo[]>('/api/farms');

export const fetchFarm = (id: string): Promise<FarmInfo> =>
  apiRequest<FarmInfo>(`/api/farms/${id}`);

export const createFarm = (body: CreateFarmInput): Promise<FarmInfo> =>
  apiRequest<FarmInfo>('/api/farms', {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const updateFarm = (id: string, body: UpdateFarmInput): Promise<FarmInfo> =>
  apiRequest<FarmInfo>(`/api/farms/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

export const deleteFarm = (id: string): Promise<void> =>
  apiRequest<void>(`/api/farms/${id}`, { method: 'DELETE' });
